export default __webpack_public_path__ + "static/media/Animals12.83656ebe.jpg";